/** @format */

import { PAYSTACK_ID } from "@/config";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getReferenceNumber = () => {
  return "dck" + Math.floor(Math.random() * 1000000000 + 1);
};

export const PayStackConfig = ({
  email,
  amount,
}: {
  email: string;
  amount: number;
}) => ({
  reference: getReferenceNumber(),
  email,
  amount: amount * 100,
  publicKey: PAYSTACK_ID,
});
